import React from 'react';
import type { MotionProps } from 'framer-motion';
import { StaggeredText } from '@/components/ui/StaggeredText';
import {
  TypographyH2,
  TypographyH3,
  TypographySmall,
} from '@/components/ui/typography';
import { cn } from '@/lib/utils';

interface SectionHeaderProperties {
  subtitle: string;
  title: string;
  description?: string;
  align?: 'center' | 'left';
  className?: string;
  subtitleMotionProps?: MotionProps;
  descriptionMotionProps?: MotionProps;
}

function SectionHeader({
  subtitle,
  title,
  description,
  align = 'center',
  className,
  subtitleMotionProps,
  descriptionMotionProps,
}: SectionHeaderProperties) {
  const alignClass = align === 'center' ? 'text-center items-center' : 'text-left items-start';

  return (
    <div
      className={cn(
        'flex flex-col gap-4 w-full md:w-2/3',
        alignClass,
        align === 'center' && 'mx-auto',
        className,
      )}
    >
      <TypographyH3
        className="font-bold text-primary uppercase tracking-wider text-sm"
        {...subtitleMotionProps}
      >
        {subtitle}
      </TypographyH3>

      <TypographyH2 className="border-b-0">
        <StaggeredText staggerChildren={0.03} delay={0.1}>
          {title}
        </StaggeredText>
      </TypographyH2>

      {description && (
        <TypographySmall
          className="text-muted-foreground"
          {...descriptionMotionProps}
        >
          {description}
        </TypographySmall>
      )}
    </div>
  );
}

export default SectionHeader;
